module.exports = __webpack_public_path__ + "img/系统管理.bb99bd9d.svg";